import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';

const Moderator = () => {
    return (
        <ProtectedRoute roles={['MODERATOR']}>
            <DashboardLayout title="Moderator Dashboard" roles={['MODERATOR']}>
                <div className="bg-white shadow rounded-lg p-6">
                    <h2 className="text-xl font-semibold mb-4">Welcome, Moderator</h2>
                    <p className="text-gray-600">
                        This is your dashboard. You can access moderator tools from the sidebar.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                            <h3 className="font-semibold text-blue-800">Review Content</h3>
                            <p className="text-sm text-blue-600 mt-1">Check flagged posts and comments.</p>
                        </div>
                        <div className="bg-green-50 p-4 rounded-lg border border-green-100">
                            <h3 className="font-semibold text-green-800">User Reports</h3>
                            <p className="text-sm text-green-600 mt-1">Handle user reported issues.</p>
                        </div>
                        <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
                            <h3 className="font-semibold text-purple-800">Activity Log</h3>
                            <p className="text-sm text-purple-600 mt-1">View recent moderation actions.</p>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </ProtectedRoute>
    );
};

export default Moderator;
